var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex align-center"},[_c('Icon',{staticClass:"mr-2",attrs:{"icon":"ChevronDownIcon","rotate":_vm.open ? '90' : undefined,"size":"12"}}),_c('b',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }